import {getMenuByProfile} from '../features/central/services'
import {toast, ToastOptions} from 'react-toastify'
import Swal from 'sweetalert2'

//Solo para mocks

// const menuMockLimpieza = [
//   {
//     vistaId: '1',
//     nombre: 'CONFIGURACION',
//     vista: '#CONFIGURACION',
//     url: null,
//     perfil: null,
//     isChildren: false,
//     opciones: [
//       {
//         opcion: 'ACCESO',
//         url: '',
//         codigo: 'ACCESO',
//       },
//     ],
//     vistas: [
//       {
//         vistaId: '1a1',
//         nombre: 'TIPOS DE EDIFICACION',
//         vista: '#TIPOS DE EDIFICACION',
//         url: null,
//         perfil: null,
//         isChildren: false,
//         opciones: [
//           {
//             opcion: 'ACCESO',
//             url: '',
//             codigo: 'ACCESO',
//           },
//           {
//             opcion: 'BUSCAR',
//             url: null,
//             codigo: 'BUSCAR',
//           },
//           {
//             opcion: 'EDITAR',
//             url: '',
//             codigo: 'EDITAR',
//           },
//           {
//             opcion: 'LISTAR',
//             url: '',
//             codigo: 'LISTAR',
//           },
//           {
//             opcion: 'NUEVO',
//             url: '',
//             codigo: 'NUEVO',
//           },
//         ],
//         vistas: [],
//       },
//       {
//         vistaId: '1a2',
//         nombre: 'CREACION DE ACTIVIDADES DE LIMPIEZA',
//         vista: '#CREACION DE ACTIVIDADES DE LIMPIEZA',
//         url: null,
//         perfil: null,
//         isChildren: false,
//         opciones: [
//           {
//             opcion: 'ACCESO',
//             url: '',
//             codigo: 'ACCESO',
//           },
//           {
//             opcion: 'BUSCAR',
//             url: '',
//             codigo: 'BUSCAR',
//           },
//           {
//             opcion: 'EDITAR',
//             url: '',
//             codigo: 'EDITAR',
//           },
//           {
//             opcion: 'LISTAR',
//             url: '',
//             codigo: 'LISTAR',
//           },
//           {
//             opcion: 'MASIVO',
//             url: null,
//             codigo: 'MASIVO',
//           },
//           {
//             opcion: 'NUEVO',
//             url: '',
//             codigo: 'NUEVO',
//           },
//         ],
//         vistas: [],
//       },
//       {
//         vistaId: '1a3',
//         nombre: 'CREACION DE CELULARES',
//         vista: '#CREACION DE CELULARES',
//         url: null,
//         perfil: null,
//         isChildren: false,
//         opciones: [
//           {
//             opcion: 'ACCESO',
//             url: '',
//             codigo: 'ACCESO',
//           },
//           {
//             opcion: 'BUSCAR',
//             url: '',
//             codigo: 'BUSCAR',
//           },
//           {
//             opcion: 'EDITAR',
//             url: '',
//             codigo: 'EDITAR',
//           },
//           {
//             opcion: 'LISTAR',
//             url: '',
//             codigo: 'LISTAR',
//           },
//           {
//             opcion: 'MASIVO',
//             url: null,
//             codigo: 'MASIVO',
//           },
//           {
//             opcion: 'NUEVO',
//             url: '',
//             codigo: 'NUEVO',
//           },
//         ],
//         vistas: [],
//       },
//     ],
//   },
// ]

// export const SetMenuMock = async (array: any[], setMenu: (e: any) => void) => {
//   try {
//     const mergedArr = MergeArrays(array, menuMockLimpieza)
//     setMenu(mergedArr)
//   } catch (error) {}
// }

//

export const SetMenu = async (
  appId: string,
  array: any[],
  setMenu: (e: any) => void,
  setPermissions: (e: any) => void = () => {},
) => {
  try {
    const {data: res} = await getMenuByProfile(appId)
    if (!res.error) {
      const mergedArr = MergeArrays(array, res.menu)
      setMenu(mergedArr)
      setPermissions(res.menu || [])
    }
  } catch (error) {}
}

export const MergeArrays = (menuHoteleria: any[], menu: any[]) => {
  const result: any[] = []
  menuHoteleria.forEach((category) => {
    const matchingCategory = menu.find((item) => item.vista === category.vista)

    if (matchingCategory) {
      const mergedCategory = {...category, opciones: matchingCategory.opciones}

      mergedCategory.arraySubItem = category.arraySubItem.map((subItem: any) => {
        const matchingSubItem = matchingCategory.vistas.find(
          (item: any) => item.vista === subItem.vista,
        )
        if (matchingSubItem) {
          return {...subItem, vistaId: matchingSubItem.vistaId, opciones: matchingSubItem.opciones}
        }
        return subItem
      })
      result.push(mergedCategory)
    }
  })
  return result
}

export const ExistPropertys = (arr: any[], property: any[]) => {
  return property.every((item) => arr.some((objeto) => item in objeto))
}

export const ExistProperty = (arr: any[], property: string) => {
  return arr.some((objeto) => property in objeto)
}

export const ExistPropertyName = (arr: any[], property: string, value: string) => {
  return arr.some((objeto) => objeto[property] === value)
}

export const ShowSnackBar = (
  message: string,
  type: string = 'success',
  options: ToastOptions = {},
) => {
  switch (type) {
    case 'success':
      toast.success(message, options)
      break
    case 'error':
      toast.error(message, options)
      break
    case 'warning':
      toast.warning(message)
      break
    case 'info':
      toast.info(message, options)
      break
    default:
      toast.success(message, options)
  }
}

type SetValueFunction = (fieldName: string, value: any) => void
type SetErrorFunction = (fieldName: string, error: any) => void
export const clearFields = (
  setValue: SetValueFunction,
  setError: SetErrorFunction,
  fieldsToClear: Record<string, any>,
) => {
  Object.keys(fieldsToClear).forEach((fieldName) => {
    setValue(fieldName, fieldsToClear[fieldName])
    setError(fieldName, {})
  })
}

export const FilterRegex = (type: string) => {
  switch (type) {
    case 'text':
      return /^[a-zA-Z\s]*$/
    case 'alphaNumeric':
      return /^[a-zA-Z0-9\s]*$/
    case 'numeric':
      return /^[0-9\s]*$/
    case 'telephone':
      return /^[0-9+\-\s]*$/
    case 'address':
      return /^[a-zA-Z0-9.,\s]*$/
    case 'any':
      return /.*/
    case 'ticketNumber':
      return /^[a-zA-Z0-9-\s]*$/
    case 'email':
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    case 'decimal':
      return /^-?\d*\.?\d*\s?[A-Za-z]*$/
    case 'twoDecimal':
      return /^-?\d*(\.\d{0,2})?$/
    default:
      return /^[a-zA-Z\s]*$/
  }
}

export const mapDataSelect = (data: any[], value: string = 'id', name: string = 'nombre') =>
  data.map((item) => ({value: item[value], label: item[name], ...item}))

export interface FormattedDate {
  fecha: string
  tiempo: string
  fechaMin: string
}
export const getFormatDate = (currentDate: any): FormattedDate | string | null => {
  if (!currentDate) {
    return ''
  }
  let formatDate = new Date(currentDate)
  let year: Date | any = formatDate.getFullYear()
  let month: Date | any = formatDate.getMonth() + 1
  let day: Date | any = formatDate.getDate()
  let hour: Date | any = formatDate.getHours()
  let minute: Date | any = formatDate.getMinutes()
  let second: Date | any = formatDate.getSeconds()

  // Formatear la salida si es necesario
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  hour = hour < 10 ? '0' + hour : hour
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second

  // Imprimir la fecha y hour
  return {
    fecha: day + '/' + month + '/' + year,
    fechaMin: year + '-' + month + '-' + day,
    tiempo: hour + ':' + minute + ':' + second,
  }
}

export const convertToNumber = (value: any) => (typeof value === 'string' ? Number(value) : value)

export const convertToDateISOString = (dateString: any) =>
  dateString ? new Date(dateString).toISOString() : ''

export const dateISOStringYMD = (dateString: any) =>
  dateString ? new Date(dateString).toISOString().slice(0, 10) : ''
export const getDataModified = (data: any) => {
  return {
    ...data,
    campoadicionalnum1: convertToNumber(data.campoadicionalnum1),
    campoadicionalnum2: convertToNumber(data.campoadicionalnum2),
    campoadicionalnum3: convertToNumber(data.campoadicionalnum3),
    campoadicionalFec1: convertToDateISOString(data.campoadicionalFec1),
    campoadicionalFec2: convertToDateISOString(data.campoadicionalFec2),
  }
}

interface PropsModalAlerts {
  title?: string
  bodyText?: string
  icon?: 'success' | 'error' | 'warning' | 'info' | 'question'
  showCancelButton?: boolean
  textButtonCancel?: string
  showConfirmButton?: boolean
  textButtonConfirm?: string
}

export const confirmModal = async ({
  title = '',
  bodyText = '',
  icon = 'info',
  showCancelButton = true,
  textButtonCancel = 'Cancelar',
  textButtonConfirm = 'Aceptar',
}: PropsModalAlerts) => {
  const result = await Swal.fire({
    title: title,
    text: bodyText,
    icon: icon,
    showCancelButton: showCancelButton,
    cancelButtonText: textButtonCancel,
    confirmButtonText: textButtonConfirm,
    confirmButtonColor: 'var(--kt-primary)',
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: () => {
      // Evitar cierre del modal hasta que manualmente devuelvas algo
      // return false
    },
  })
  return result
}

export const chunkArray = (array: any[], size: number) => {
  if (!Array.isArray(array)) {
    throw new Error('El primer argumento debe ser un arreglo.')
  }
  if (typeof size !== 'number' || size <= 0) {
    throw new Error('El tamaño del grupo debe ser un número positivo.')
  }

  const chunkedArray = []
  for (let i = 0; i < array.length; i += size) {
    const chunk = array.slice(i, i + size)
    chunkedArray.push(chunk)
  }
  return chunkedArray
}
